import { createFileRoute } from '@tanstack/react-router'
import { MaintenanceBanner } from '@/components/maintenance-banner'

export const Route = createFileRoute('/maintenance')({
  component: MaintenancePage,
})

function MaintenancePage() {
  return (
    <div className="grid w-full min-h-svh lg:grid-cols-2">
      <div className="flex flex-col p-6 md:p-10 lg:p-12">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="#" className="flex items-center gap-2 font-medium">
            <img
              src={`${import.meta.env.BASE_URL}assets/logo_with_text_side.svg`}
              alt="Supplyco Logo"
              className="h-10 w-auto object-contain md:h-12"
            />
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md space-y-6">
            <MaintenanceBanner />
            <div className="space-y-4 text-sm text-muted-foreground text-center">
              <p>We&apos;ll be back soon. This shouldn&apos;t take long.</p>
              <p>
                If you need immediate assistance, contact us at
                {' '}
                <a
                  href="mailto:support@supplyco.ai"
                  className="text-blue-600 hover:underline"
                >
                  support@supplyco.ai
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block">
        <img
          src={`${import.meta.env.BASE_URL}assets/login-image.png`}
          alt="Login illustration"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </div>
  )
}
